const BLOCK = "p|h[1-6]|li|div";
const INLINE = "a|b|code|em|font|i|mark|s|small|span|strong|sub|sup|u";
const INLINE_TAG = String.raw`<\/?(?:${INLINE})\b[^>]*>`;
const INLINE_CLOSE = String.raw`<\/(?:${INLINE})>`;

const trailingBreak = new RegExp(
  String.raw`<br[^>]*>((?:\s|${INLINE_CLOSE})*)(?=<\/(?:${BLOCK})>)`,
  "gi",
);
const emptyBlock = new RegExp(
  String.raw`(<(${BLOCK})\b[^>]*>)(?:\s|${INLINE_TAG})*<\/\2>`,
  "gi",
);

export const toLines = (text: string) =>
  text
    .replace(/\r\n?|[\u2028\u2029]/g, "\n")
    .replace(/^\n+|\n+$/g, "")
    .split("\n");

export const plainTextToHtml = (text: string) =>
  /<\/?[a-z][\s\S]*>/i.test(text)
    ? text
    : toLines(text)
        .map((line) => `<p>${line.trim() ? line : ""}</p>`)
        .join("");

// ProseMirror shows a block that is empty or ends in a line break one line taller than a browser does.
export const matchEditorSpacing = (html: string) =>
  plainTextToHtml(html)
    .replace(trailingBreak, "<br>$1<br>")
    .replace(emptyBlock, "$1<br></$2>");
